import { j as e } from "../../jsx-runtime-82a9ddf6.js";
import { cn as s } from "../../lib/cn.js";
const p = [
  "border dark:border-transparent",
  "border-slate-200",
  "rounded-lg",
  "bg-white dark:bg-slate-700",
  "leading-[17px]",
  "text-base",
  "text-slate-900",
  "font-normal",
  "active:border-purple-600 dark:active:border-purple-600",
  "focus:border-purple-600 dark:focus:border-purple-600",
  "focus-within:border-purple-600 dark:focus-within:border-purple-600",
  "hover:border-purple-600 dark:hover:border-purple-600",
  "placeholder:text-slate-300",
  "placeholder:dark:text-slate-500",
  "disabled:bg-slate-50",
  "disabled:border-slate-200",
  "shadow-[inset_0_1px_2px_rgba(16,24,40,0.05)]",
  "transition-[border-color_0.3s_ease]",
  "flex",
  "items-center"
], d = [
  "bg-white dark:bg-slate-700",
  "text-slate-900 dark:text-white",
  "appearance-none",
  "w-full",
  "h-full",
  "outline-none",
  "flex-1"
], b = [
  "h-[40px]",
  "max-h-[40px]"
], u = [
  "h-auto",
  "max-h-none",
  "resize-none"
], h = [
  "px-3.5"
], m = [
  "py-3",
  "px-4"
], f = [
  "border-red-600",
  "active:border-red-600",
  "hover:border-red-600",
  "focus:border-red-600"
], w = ({
  id: o,
  label: a,
  error: t,
  className: l,
  containerClassName: n,
  wrapperClassName: i,
  prefix: x,
  suffix: c,
  ...r
}) => /* @__PURE__ */ e.jsxs("div", { className: s("space-y-3", n), children: [
  !!a && /* @__PURE__ */ e.jsx("label", { htmlFor: o, className: "block text-sm text-slate-500 dark:text-slate-400 font-medium", children: a }),
  /* @__PURE__ */ e.jsxs("div", { className: s(p, r.multiline ? m : h, !!t && f, i), children: [
    x,
    r.multiline ? /* @__PURE__ */ e.jsx(
      "textarea",
      {
        ...r,
        rows: r.rows ?? 3,
        className: s(d, u, l)
      }
    ) : /* @__PURE__ */ e.jsx(
      "input",
      {
        ...r,
        className: s(d, b, l)
      }
    ),
    c
  ] }),
  !!t && typeof t == "string" && /* @__PURE__ */ e.jsx("div", { className: "text-xs text-red-500", children: t })
] });
export {
  w as TextInput,
  w as default
};
